// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__J--h9","footer_container":"Footer_footer_container__eL-db","p":"Footer_p__W4bLY"};